import {Nullish} from 'shared/web';

export interface FeaturePickerItem {
  value: string;
  label: string;
  shortLabel?: string | null;
  categories?: Array<
    | {
        value: string;
        label: string;
        shortLabel: string;
      }
    | string
  >;
  /**
   * Catalogue feature subcategory key, used to group root features within a category.
   */
  subCategory?: string | Nullish;
  children?: Array<FeaturePickerItem>;
}
